import http from './http'

const usuariosfornecedoresService = {
  getAll: page => http.get(`/usuariosfornecedores?page=${page}`).then(result => result.data),
  getById: id => http.get(`/usuariosfornecedoresgetid/${id}`).then(result => result.data.data),
  getByAll: () => http.get(`/usuariosfornecedores`).then(result => result.data),
  getByUsuario: () => http.get(`/usuariosfornecedoresall`).then(result => result.data),
  delete: id => http.delete(`/usuariosfornecedoresdelete/${id}`).then(result => result.data.data),
  savePost: data => http({
    method: 'post',
    url: `/usuariosfornecedores`,
    data
  }).then(result => result.data.data),
  savePut: data => http({
    method: 'put',
    url: `/usuariosfornecedoresput/${data.id}`,
    data
  }).then(result => result.data.data)
}
export default usuariosfornecedoresService
